// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import { get, merge } from 'lodash';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {statusGroupOrDefault} from '../../../../redux/helpers/staticData';
import CompanyManager from './CompanyManager';
import CardModal from '../../../../common/components/с_cardModal';
import CompanyCard from './Card';

// redux interactions
import * as asyncActionCreator from '../../../../redux/actionCreators/async';


@connect((store, props) => ({
  user: store.user,
  staticData: store.staticData,
  status: statusGroupOrDefault(props.params.navColumnState, store.user.companyStatusList),
  companyStatusList: (store.user.companyStatusList || []).slice().sort((objA, objB) => objA - objB),
  companiesLoaded: get(store.admin.companies, 'items', []),
  contacts: get(store.admin.contacts, 'items', []),
  companies: store.admin.companies,
  route: {
    params: props.params,
    query: props.location.query
  } // actually being from from react-redux-router to regular props
}))
export default class CompaniesDashboard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    route: PropTypes.object,
    location: PropTypes.object,
    query: PropTypes.object,
    params: PropTypes.object, // comes from react-redux-router
    user: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
  }
  state = {
    selectedCompany: null,
    statusDropdown : {
      list : this.props.staticData.companyStatus,
      value :  0,
    }
  }


  componentWillMount() {
    this.props.dispatch(asyncActionCreator.searchCompanies(this.props.route.query.search || []));

    // load contacts in case they're not in yet
    if (!this.props.contacts) {
      this.props.dispatch(asyncActionCreator.searchContacts(this.props.route.query.search || []));
    }

    //if we have company in url params - need load it for card information
    if (get(this.props,'route.query.card', false)) {
      this.props.dispatch(asyncActionCreator.getCompanyById(this.props.route.query.card,  {
          success : (data) => {
            this.setState(merge({}, this.state, {
              selectedCompany: data.items[0],
              statusDropdown: {value: data.items[0].companyStatus}
            }));
            cb();
          },
          error :(err) => {
            console.log('error update store', err);
            return cb(err);
          }
      }));
    }
  }

  componentWillUpdate(nextProps) {
    if(nextProps.route.query.card && (nextProps.route.query.card !== this.props.route.query.card)) {
      this.props.dispatch(asyncActionCreator.getCompanyById(nextProps.route.query.card,  {
          success :(data) => {
          this.setState(merge({}, this.state, {
          selectedCompany: data.items[0],
          statusDropdown: {value: data.items[0].companyStatus}
        }));
      cb();
      },
        error :(err) => {
          console.log('error update store', err);
          return cb(err);
        }
      }));
    }

  }

  onChange(value) {
    this.setState(merge({}, this.state, {
      statusDropdown: {value}
    }));
  }

  searchCompanies(terms = [], filters = {}) {
    this.props.dispatch(asyncActionCreator.searchCompanies(terms, filters));
  }

  closeCompanyCard() {
    this.setState(merge({}, this.state, {
      selectedCompany: null
    }));
  }
  render() {
    return (

      <div className='admin-content-container companies-dashboard clearfix'>

    {this.state.selectedCompany ?
        <CardModal
          statusDropdown={this.state.statusDropdown}
          onChange={this.onChange.bind(this)}
        >
          <CompanyCard
            company={this.state.selectedCompany}
            dispatch={this.props.dispatch}
            route={this.props.route}
            onClose={this.closeCompanyCard.bind(this)}
          />
      </CardModal>
    : null}


        <CompanyManager
          navColumnState={this.props.status}
          searchCompanies={::this.searchCompanies}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Dashboard/index.js